const initialState = [];

const reductions = {
  NEW_SAVED_REPLY: function (state, action) {
    const foundReply = state.find((reply) => reply.id === action.payload.id);
    if (foundReply) {
      return state;
    }
    return state.concat(action.payload);
  },
  NEW_SAVED_REPLIES: function (state, action) {
    return state.concat(action.payload);
  },
  UPDATE_SAVED_REPLY: function (state, action) {
    let replyFound = false;
    const newReplies = state.map((reply) => {
      if (reply.id === action.payload.id) {
        replyFound = true;
        return action.payload;
      }
      return reply;
    });
    if (!replyFound) {
      return newReplies.concat(action.payload);
    }
    return newReplies;
  },
  DELETE_SAVED_REPLY: function (state, action) {
    return state.filter((r) => r.id !== action.payload.id);
  },
  PIN_SAVED_REPLY: function (state, action) {
    const toPin = state.find((x) => x.id === action.payload.id);

    if (toPin.pinned) {
      return state;
    }

    const updated = {
      ...toPin,
      pinned: true,
    };

    const updatedState = [...state.filter((x) => x.id !== action.payload.id)];

    updatedState.push(updated);

    return updatedState;
  },
  UNPIN_SAVED_REPLY: function (state, action) {
    const toPin = state.find((x) => x.id === action.payload.id);

    if (!toPin.pinned) {
      return state;
    }

    const updated = {
      ...toPin,
      pinned: false,
    };
    const updatedState = [...state.filter((x) => x.id !== action.payload.id)];

    updatedState.push(updated);

    return updatedState;
  },
};

const savedRepliesReducer = (state = initialState, action) => {
  if (action && action.type && reductions[action.type]) {
    return reductions[action.type](state, action);
  }
  return state;
};

export default savedRepliesReducer;
